import { IFormActualsTargetsSettings } from 'legacy/lut/classes/models/partner360/IFormActualsTargetsSettings'
import {
  IFormPartnerShareOfBusiness,
  IFormSOBItem,
} from 'legacy/lut/classes/models/partner360/IFormPartnerShareOfBusiness'
import {
  IFormShareOfBusiness,
  IFormShareOfBusinessItem,
} from 'legacy/lut/classes/models/partner360/IFormShareOfBusiness'

import { OVERALL_CATEGORY } from '../config'

export default class ShareOfBusinessHelper {
  //
  // Methods, used in actual ShareOfBusiness widget
  //

  public static normalizeDataBySubCategoriesTwoLevels = (
    partnerId: string,
    programType: string,
    category: string,
    fyear: number,
    data: IFormShareOfBusiness[],
    isHideOverall: boolean,
    formats: IFormActualsTargetsSettings[]
  ): IFormShareOfBusinessItem[] => {
    const result: IFormShareOfBusinessItem[] = []

    formats
      .filter((format) => (isHideOverall ? format.SubCategory !== OVERALL_CATEGORY : true))
      .map((format) => {
        const item = data.find((el) => el.SubCategory === format.SubCategory)
        result.push(
          item
            ? {
                ...item,

                // Item fields
                Changed: false,
                Delete: false,
              }
            : {
                UniqueId: '',

                EntryId: 0,

                PartnerId: partnerId,
                ProgramType: programType,
                FYear: fyear,
                BusinessUnit: '',
                Category: category,
                SubCategory: format.SubCategory,

                IsStore: 0,

                ActualQ1: 0,
                ActualQ2: 0,
                ActualQ3: 0,
                ActualQ4: 0,
                ActualQ1Rev: 0,
                ActualQ2Rev: 0,
                ActualQ3Rev: 0,
                ActualQ4Rev: 0,
                ActualQ1Prev: 0,
                ActualQ2Prev: 0,
                ActualQ3Prev: 0,
                ActualQ4Prev: 0,
                ActualQ1RevPrev: 0,
                ActualQ2RevPrev: 0,
                ActualQ3RevPrev: 0,
                ActualQ4RevPrev: 0,

                PlanQ1: 0,
                PlanQ2: 0,
                PlanQ3: 0,
                PlanQ4: 0,
                PlanQ1Rev: 0,
                PlanQ2Rev: 0,
                PlanQ3Rev: 0,
                PlanQ4Rev: 0,
                PlanQ1Prev: 0,
                PlanQ2Prev: 0,
                PlanQ3Prev: 0,
                PlanQ4Prev: 0,
                PlanQ1RevPrev: 0,
                PlanQ2RevPrev: 0,
                PlanQ3RevPrev: 0,
                PlanQ4RevPrev: 0,

                // Item fields
                Changed: false,
                Delete: false,
              }
        )
      })

    return result
  }

  public static calcPercentFieldsGrowth = (sobData: IFormShareOfBusinessItem[]) => {
    const itemsWithGrow = sobData.map((el) => {
      el.ActualQ1Grow = ShareOfBusinessHelper.calcPercentDiff(el?.ActualQ1Prev, el.ActualQ1)
      el.ActualQ2Grow = ShareOfBusinessHelper.calcPercentDiff(el?.ActualQ2Prev, el.ActualQ2)
      el.ActualQ3Grow = ShareOfBusinessHelper.calcPercentDiff(el?.ActualQ3Prev, el.ActualQ3)
      el.ActualQ4Grow = ShareOfBusinessHelper.calcPercentDiff(el?.ActualQ4Prev, el.ActualQ4)
      el.ActualFYGrow = ShareOfBusinessHelper.calcPercentDiff(el?.ActualFYPrev, el.ActualFY)

      el.PlanQ1Grow = ShareOfBusinessHelper.calcPercentDiff(el?.ActualQ1Prev, el.PlanQ1)
      el.PlanQ2Grow = ShareOfBusinessHelper.calcPercentDiff(el?.ActualQ2Prev, el.PlanQ2)
      el.PlanQ3Grow = ShareOfBusinessHelper.calcPercentDiff(el?.ActualQ3Prev, el.PlanQ3)
      el.PlanQ4Grow = ShareOfBusinessHelper.calcPercentDiff(el?.ActualQ4Prev, el.PlanQ4)
      el.PlanFYGrow = ShareOfBusinessHelper.calcPercentDiff(el?.ActualFYPrev, el.PlanFY)

      return el
    })

    return itemsWithGrow
  }

  public static calcPercentDiff = (prev: number, curr: number) => {
    const diff = (((curr || 0) - (prev || 0)) * 100).toFixed(2)

    return Number(diff)
  }

  public static updatePercentField = (
    data: IFormShareOfBusinessItem[],
    idx: number,
    field: string,
    value: number
  ) => {
    const item = {
      ...data[idx],
      [field]: value / 100,

      Delete: false,
    }

    data.splice(idx, 1, {
      ...item,

      Changed: true,
    })

    return data
  }

  public static cleanDataForAPI = (sobData: IFormShareOfBusinessItem[]) => {
    const cleanData = sobData.map((el) => {
      return {
        Category: el.Category,
        SubCategory: el.SubCategory,

        ActualQ1: el.ActualQ1,
        ActualQ2: el.ActualQ2,
        ActualQ3: el.ActualQ3,
        ActualQ4: el.ActualQ4,
        ActualFY: el.ActualFY,

        PlanQ1: el.PlanQ1,
        PlanQ2: el.PlanQ2,
        PlanQ3: el.PlanQ3,
        PlanQ4: el.PlanQ4,
        PlanFY: el.PlanFY,

        ActualQ1Prev: el.ActualQ1Prev,
        ActualQ2Prev: el.ActualQ2Prev,
        ActualQ3Prev: el.ActualQ3Prev,
        ActualQ4Prev: el.ActualQ4Prev,
        ActualFYPrev: el.ActualFYPrev,
      }
    })

    return cleanData
  }

  //
  // Methods used in ShareOfBusinessWithBrands widgets
  //

  public static brandArr = ['Brand1Name', 'Brand2Name', 'Brand3Name', 'Brand4Name']

  public static setLayer = (value: string) => {
    switch (value.toLowerCase()) {
      case 'ink':
        return `sob-ink`
      case 'toner':
        return `sob-toner`
      default:
        return ''
    }
  }

  public static adjustBrands = (data: IFormSOBItem[]) => {
    let brand1 = ''
    let brand2 = ''
    let brand3 = ''
    let brand4 = ''
    data.map((el) => {
      if (!brand1 && el.Brand1Name) {
        brand1 = el.Brand1Name
      }
      if (!brand2 && el.Brand2Name) {
        brand2 = el.Brand2Name
      }
      if (!brand3 && el.Brand3Name) {
        brand3 = el.Brand3Name
      }
      if (!brand4 && el.Brand4Name) {
        brand4 = el.Brand4Name
      }
    })

    return data.map((el) => {
      return {
        ...el,
        Brand1Name: brand1,
        Brand2Name: brand2,
        Brand3Name: brand3,
        Brand4Name: brand4,
      }
    })
  }

  public static getData = (
    partnerId: string,
    programType: string,
    category: string,
    fyear: number,
    data: IFormPartnerShareOfBusiness[],
    hideOverall: boolean,
    formats: IFormActualsTargetsSettings[]
  ): IFormSOBItem[] => {
    const result: IFormSOBItem[] = []
    formats
      .filter((format) => (hideOverall ? format.SubCategory !== OVERALL_CATEGORY : true))
      .map((format) => {
        const item = data.find((el) => el.SubCategory === format.SubCategory)
        result.push(
          item
            ? {
                ...ShareOfBusinessHelper.calcOther(item as any),
                Changed: false,
                Delete: false,
              }
            : {
                EntryId: 0,
                PartnerId: partnerId,
                ProgramType: programType,
                Type: category,
                FYear: fyear,
                Layer: format.SubCategory,
                Brand1Name: '',
                Brand2Name: '',
                Brand3Name: '',
                Brand4Name: '',
                Brand1Percent: 0,
                Brand2Percent: 0,
                Brand3Percent: 0,
                Brand4Percent: 0,
                HPPercent: 0,
                OtherPercent: 1,
                HPPointsGrowth: 0,
                HPPercentPrevYear: 0,
                Category: category,
                SubCategory: format.SubCategory,
                Changed: false,
                Delete: false,
              }
        )
      })

    return result
  }

  public static calcOverall = (data: IFormSOBItem[]) => {
    const idx = data.findIndex((el) => (el.Layer || '').indexOf('-overall') > -1)
    if (idx < 0) {
      return data
    }
    const overall: IFormSOBItem = {
      ...data[idx],
      Brand1Percent: 0,
      Brand2Percent: 0,
      Brand3Percent: 0,
      Brand4Percent: 0,
      OtherPercent: 0,
      HPPercent: 0,
      HPPointsGrowth: 0,
      HPPercentPrevYear: 0,
    }
    data.map((el, index) => {
      if (index !== idx) {
        overall.Brand1Percent += el.Brand1Percent
        overall.Brand2Percent += el.Brand2Percent
        overall.Brand3Percent += el.Brand3Percent
        overall.Brand4Percent += el.Brand4Percent
        overall.OtherPercent += el.OtherPercent
        overall.HPPercent += el.HPPercent
        overall.HPPointsGrowth += el.HPPointsGrowth
        overall.HPPercentPrevYear += el.HPPercentPrevYear
      }
    })
    overall.Brand1Percent /= data.length - 1
    overall.Brand2Percent /= data.length - 1
    overall.Brand3Percent /= data.length - 1
    overall.Brand4Percent /= data.length - 1

    overall.OtherPercent /= data.length - 1
    overall.HPPercent /= data.length - 1
    overall.HPPointsGrowth /= data.length - 1
    overall.HPPercentPrevYear /= data.length - 1
    data.splice(idx, 1, overall)

    return data
  }

  public static changeBrand = (data: IFormSOBItem[], value: string, field: string) => {
    return data.map((el) => {
      return {
        ...el,
        [field]: value,
        Changed: true,
      }
    })
  }

  public static recalcOnExpand = (data: IFormSOBItem[]) => {
    if (data && data.length) {
      const overallIdx = data.findIndex((el) => el.SubCategory.endsWith('-overall'))
      const otherIdx = data.findIndex((el) => el.SubCategory.endsWith('-other'))
      if (overallIdx > -1 && otherIdx > -1) {
        const fields = [
          'Brand1Percent',
          'Brand2Percent',
          'Brand3Percent',
          'Brand4Percent',
          'HPPercent',
        ]
        let total = 0
        fields.map((field) => {
          let value = 0
          data.map((el, idx) => {
            if (idx !== overallIdx && idx !== otherIdx) {
              value += el[field]
            }
          })
          data[otherIdx][field] = data[overallIdx][field] - value
          total += data[otherIdx][field]
        })
        // re-calc HPPointsGrowth
        let points = data[otherIdx].HPPointsGrowth || 0
        const percent = (
          ((data[otherIdx].HPPercent || 0) - (data[otherIdx].HPPercentPrevYear || 0)) /
          (data[otherIdx].HPPercentPrevYear || 1)
        ).toFixed(2)
        points = Number(percent)
        data[otherIdx].HPPointsGrowth = points
        // re-calc OtherPercent other
        data[otherIdx].OtherPercent = 1 - total

        return data
      }
    }

    return undefined
  }

  public static clearBrand = (data: IFormSOBItem[], field: string) => {
    return data.map((el) => {
      const item = {
        ...el,
        [field]: '',
        [field.replace('Name', 'Percent')]: 0,
        Changed: true,
      }
      const other =
        1 -
        (item.Brand1Percent +
          item.Brand2Percent +
          item.Brand3Percent +
          item.Brand4Percent +
          item.HPPercent)

      return { ...item, OtherPercent: other }
    })
  }

  public static checkBrand = async (value: string, field: string, item: IFormSOBItem) => {
    let result = false
    ShareOfBusinessHelper.brandArr.map((brand) => {
      if (!value || result || brand === field) {
        return
      }
      result = item[brand] === value
    })

    return result ? 'Brand already selected' : ''
  }

  public static calcOther = (item: IFormSOBItem): IFormSOBItem => {
    const other =
      1 -
      (item.Brand1Percent +
        item.Brand2Percent +
        item.Brand3Percent +
        item.Brand4Percent +
        item.HPPercent)

    return { ...item, OtherPercent: other }
  }

  // Not used
  public static markOnDelete = (data: IFormSOBItem[], layer: string) => {
    if (layer.indexOf('overall') > -1) {
      return data.map((el) => {
        return {
          ...el,
          Delete: el.Layer.indexOf('overall') === -1,
        }
      })
    } else {
      return data.map((el) => {
        return {
          ...el,
          Delete: el.Layer.indexOf('overall') > -1,
        }
      })
    }
  }

  public static changePercent = (
    data: IFormSOBItem[],
    idx: number,
    field: string,
    value: number,
    isOverall: boolean
  ) => {
    const item = ShareOfBusinessHelper.calcOther({
      ...data[idx],
      [field]: value / 100,
      Delete: false,
    })
    let points = item.HPPointsGrowth
    if (field === 'HPPercent' && item.HPPercentPrevYear) {
      const percent = ((item.HPPercent - item.HPPercentPrevYear) / item.HPPercentPrevYear).toFixed(
        2
      )
      points = Number(percent)
    }
    data.splice(idx, 1, {
      ...item,
      HPPointsGrowth: points,
      Changed: true,
    })

    return isOverall ? data : ShareOfBusinessHelper.calcOverall(data)
  }

  public static getHPGrowth = (item: IFormSOBItem) => {
    if (item.HPPointsGrowth) {
      return ((item.HPPointsGrowth || 0) * 100).toFixed(0)
    }
    if (item.HPPercentPrevYear) {
      return (((item.HPPercent - item.HPPercentPrevYear) / item.HPPercentPrevYear) * 100).toFixed(0)
    }

    return ''
  }

  public static capitalizeType = (type: string) => {
    return type[0].toUpperCase() + type.slice(1)
  }

  //
  // Methods used in ShareOfBusinessWithRevenue widget
  //

  public static getShareOfBusinessGrowth = (item: IFormShareOfBusinessItem) => {
    if (item.HPPointsGrowth) {
      return ((item.HPPointsGrowth || 0) * 100).toFixed(0)
    }
    if (item.HPPercentPrevYear) {
      return (((item.HPPercent - item.HPPercentPrevYear) / item.HPPercentPrevYear) * 100).toFixed(0)
    }

    return ''
  }

  public static recalcShareOfBusinessOnExpand = (data: IFormShareOfBusinessItem[]) => {
    if (data && data.length) {
      const overallIdx = data.findIndex((el) => el.SubCategory.endsWith('-overall'))
      const otherIdx = data.findIndex((el) => el.SubCategory.endsWith('-other'))

      if (overallIdx > -1 && otherIdx > -1) {
        const quarters = [1, 2, 3, 4]
        quarters.map((quarter) => {
          const actualField = `ActualQ${quarter}`
          const planField = `PlanQ${quarter}`

          let actualValue = 0
          let planValue = 0
          data.map((el, idx) => {
            if (idx !== overallIdx && idx !== otherIdx) {
              actualValue += el[actualField]
              planValue += el[planField]
            }
          })

          data[otherIdx][actualField] = data[overallIdx][actualField] - actualValue
          data[otherIdx][planField] = data[overallIdx][planField] - planValue
        })

        // re-calc HPPointsGrowth
        //let points = data[otherIdx].HPPointsGrowth || 0
        //const percent = (
        //  ((data[otherIdx].HPPercent || 0) - (data[otherIdx].HPPercentPrevYear || 0)) /
        //  (data[otherIdx].HPPercentPrevYear || 1)
        //).toFixed(2)
        //points = Number(percent)
        //data[otherIdx].HPPointsGrowth = points

        return data
      }
    }

    return undefined
  }

  public static changeShareOfBusinessPercent = (
    data: IFormShareOfBusinessItem[],
    idx: number,
    field: string,
    value: number,
    isOverall: boolean
  ) => {
    const item = {
      ...data[idx],
      [field]: value / 100,
      Delete: false,
    }

    //let points = item.HPPointsGrowth
    //if (field === 'HPPercent' && item.HPPercentPrevYear) {
    //  const percent = ((item.HPPercent - item.HPPercentPrevYear) / item.HPPercentPrevYear).toFixed(        2      )
    //  points = Number(percent)
    //}

    data.splice(idx, 1, {
      ...item,
      //HPPointsGrowth: points,
      Changed: true,
    })

    return isOverall ? data : ShareOfBusinessHelper.recalcOverallItem(data)
  }

  public static changeShareOfBusinessRevenue = (
    data: IFormShareOfBusinessItem[],
    idx: number,
    field: string,
    value: number,
    isOverall: boolean
  ) => {
    const item = {
      ...data[idx],
      [field]: value,
      Delete: false,
    }

    data.splice(idx, 1, {
      ...item,
      //HPPointsGrowth: points,
      Changed: true,
    })

    return isOverall ? data : ShareOfBusinessHelper.recalcOverallItem(data)
  }

  public static recalcOverallItem = (data: IFormShareOfBusinessItem[]) => {
    const idx = data.findIndex((el) => (el.SubCategory || '').indexOf('-overall') > -1)
    if (idx < 0) {
      return data
    }

    const overall: IFormShareOfBusinessItem = {
      ...data[idx],

      ActualQ1: 0,
      ActualQ2: 0,
      ActualQ3: 0,
      ActualQ4: 0,
      PlanQ1: 0,
      PlanQ2: 0,
      PlanQ3: 0,
      PlanQ4: 0,
    }
    data.map((el, index) => {
      if (index !== idx) {
        overall.ActualQ1 += el.ActualQ1
        overall.ActualQ2 += el.ActualQ2
        overall.ActualQ3 += el.ActualQ3
        overall.ActualQ4 += el.ActualQ4
        overall.PlanQ1 += el.PlanQ1
        overall.PlanQ2 += el.PlanQ2
        overall.PlanQ3 += el.PlanQ3
        overall.PlanQ4 += el.PlanQ4
      }
    })
    const notOverallDataLength = data.length - 1
    overall.ActualQ1 /= notOverallDataLength
    overall.ActualQ2 /= notOverallDataLength
    overall.ActualQ3 /= notOverallDataLength
    overall.ActualQ4 /= notOverallDataLength
    overall.PlanQ1 /= notOverallDataLength
    overall.PlanQ2 /= notOverallDataLength
    overall.PlanQ3 /= notOverallDataLength
    overall.PlanQ4 /= notOverallDataLength

    data.splice(idx, 1, overall)

    return data
  }

  //
  // Calculated Grow as the ratio of quarters following one after another
  // (for the first quarter, the last quarter of the previous year is taken)
  //
  public static calcGrowBySequenceOfQuarters = (sobData: IFormShareOfBusinessItem[]) => {
    const itemsWithGrow = sobData.map((el) => {
      //
      // Calc Grow in Percent
      //
      el.ActualQ1Grow = ShareOfBusinessHelper.calcGrow(el.ActualQ4Prev, el.ActualQ1)
      el.ActualQ2Grow = ShareOfBusinessHelper.calcGrow(el.ActualQ1, el.ActualQ2)
      el.ActualQ3Grow = ShareOfBusinessHelper.calcGrow(el.ActualQ2, el.ActualQ3)
      el.ActualQ4Grow = ShareOfBusinessHelper.calcGrow(el.ActualQ3, el.ActualQ4)

      el.PlanQ1Grow = ShareOfBusinessHelper.calcGrow(el.PlanQ4Prev, el.PlanQ1)
      el.PlanQ2Grow = ShareOfBusinessHelper.calcGrow(el.PlanQ1, el.PlanQ2)
      el.PlanQ3Grow = ShareOfBusinessHelper.calcGrow(el.PlanQ2, el.PlanQ3)
      el.PlanQ4Grow = ShareOfBusinessHelper.calcGrow(el.PlanQ3, el.PlanQ4)
      //
      // Calc Grow in Value for Revenue
      //
      el.ActualQ1RevGrow = ShareOfBusinessHelper.calcDiff(el.ActualQ4RevPrev, el.ActualQ1Rev)
      el.ActualQ2RevGrow = ShareOfBusinessHelper.calcDiff(el.ActualQ1Rev, el.ActualQ2Rev)
      el.ActualQ3RevGrow = ShareOfBusinessHelper.calcDiff(el.ActualQ2Rev, el.ActualQ3Rev)
      el.ActualQ4RevGrow = ShareOfBusinessHelper.calcDiff(el.ActualQ3Rev, el.ActualQ4Rev)
      el.PlanQ1RevGrow = ShareOfBusinessHelper.calcPlanRevGrow(
        el.ActualQ4RevPrev,
        el.PlanQ4RevPrev,
        el.PlanQ1Rev
      )
      el.PlanQ2RevGrow = ShareOfBusinessHelper.calcPlanRevGrow(
        el.ActualQ1Rev,
        el.PlanQ1Rev,
        el.PlanQ2Rev
      )
      el.PlanQ3RevGrow = ShareOfBusinessHelper.calcPlanRevGrow(
        el.ActualQ2Rev,
        el.PlanQ2Rev,
        el.PlanQ3Rev
      )
      el.PlanQ4RevGrow = ShareOfBusinessHelper.calcPlanRevGrow(
        el.ActualQ3Rev,
        el.PlanQ3Rev,
        el.PlanQ4Rev
      )

      return el
    })

    return itemsWithGrow
  }

  //
  // Calc Grow as Percent
  //
  private static calcGrow = (prev: number, curr: number) => {
    const percent = ((((curr || 0) - (prev || 0)) / (prev || 1)) * 100).toFixed(2)

    return Number(percent)
  }

  //
  // Calc Grow as Diff
  //
  private static calcDiff = (prev: number, curr: number) => {
    const diff = ((curr || 0) - (prev || 0)).toFixed(2)

    return Number(diff)
  }

  //
  // Calc Plan Grow as Diff
  //
  private static calcPlanRevGrow = (
    actualRevPrev: number,
    planRevPrev: number,
    planRev: number
  ) => {
    let grow = 0

    if (actualRevPrev) {
      grow = Number(((planRev || 0) - (actualRevPrev || 0)).toFixed(2))
    } else if (planRevPrev) {
      grow = Number(((planRev || 0) - (planRevPrev || 0)).toFixed(2))
    }

    return Number(grow)
  }

  //
  // Calculated Revenue
  //
  public static calcPlanRevenueBySequenceOfQuarters = (sobData: IFormShareOfBusinessItem[]) => {
    const itemsWithRevenue = sobData.map((el) => {
      el.PlanQ1Rev = ShareOfBusinessHelper.calcPlanRevenue(
        el.ActualQ4RevPrev,
        el.ActualQ4Prev,
        el.PlanQ4RevPrev,
        el.PlanQ4Prev,
        el.PlanQ1
      )
      el.PlanQ2Rev = ShareOfBusinessHelper.calcPlanRevenue(
        el.ActualQ1Rev,
        el.ActualQ1,
        el.PlanQ1Rev,
        el.PlanQ1,
        el.PlanQ2
      )
      el.PlanQ3Rev = ShareOfBusinessHelper.calcPlanRevenue(
        el.ActualQ2Rev,
        el.ActualQ2,
        el.PlanQ2Rev,
        el.PlanQ2,
        el.PlanQ3
      )
      el.PlanQ4Rev = ShareOfBusinessHelper.calcPlanRevenue(
        el.ActualQ3Rev,
        el.ActualQ3,
        el.PlanQ3Rev,
        el.PlanQ3,
        el.PlanQ4
      )

      return el
    })

    return itemsWithRevenue
  }

  private static calcPlanRevenue = (
    actualRevPrev: number,
    actualPrev: number,
    planRevPrev: number,
    planPrev: number,
    plan: number
  ) => {
    let revenue = 0

    if (!!actualRevPrev && !!actualPrev) {
      revenue = (actualRevPrev / actualPrev) * (plan || 0)
    } else if (!!planRevPrev && !!planPrev) {
      revenue = (planRevPrev / planPrev) * (plan || 0)
    }

    return Number(revenue)
  }
}
